import { isNotFoundError } from '@/services/api';
import type { ThirdPartyInvoiceableDealer } from '../types/thirdPartyAgreement.types';

export type ThirdPartyDealerFieldState = 'gated' | 'loading' | 'not-found' | 'failed' | 'empty' | 'ready';

interface DealersQueryView {
    isError: boolean;
    error: unknown;
    data: ThirdPartyInvoiceableDealer[] | undefined;
}

export function selectedInvoicingDealer(
    dealers: ThirdPartyInvoiceableDealer[],
    choice: string | null,
): ThirdPartyInvoiceableDealer | null {
    const chosen = dealers.find((dealer) => dealer.encryptedId === choice);

    if (chosen) {
        return chosen;
    }

    return dealers.length === 1 ? dealers[0] : null;
}

export function thirdPartyDealerFieldState(permitted: boolean, query: DealersQueryView): ThirdPartyDealerFieldState {
    if (!permitted) {
        return 'gated';
    }

    if (query.isError) {
        return isNotFoundError(query.error) ? 'not-found' : 'failed';
    }

    if (query.data === undefined) {
        return 'loading';
    }

    return query.data.length === 0 ? 'empty' : 'ready';
}
